import PropTypes from "prop-types";
import React from "react";
import styles from "./styles.css";
import { Label } from "@cars24/turbo-web/lib/label";
import { NUMBER } from "../../../constants/app-constants";

const VehicleAccordion = ({
    heading,
    ContentComponent,
    isHistory = false,
    ...additionalProps
}) => {

    return (
        <div styleName={"styles.listWrapper"}>
            <Label level={NUMBER.TWO} fontWeight="semibold">Select car {heading}</Label>
            <ContentComponent isHistory={isHistory} {...additionalProps} />
        </div>
    );
};

export default VehicleAccordion;

VehicleAccordion.propTypes = {
    heading: PropTypes.string,
    ContentComponent: PropTypes.elementType,
    isHistory: PropTypes.bool
};
